import React from 'react';
import { Pagination as PaginationComponent, PaginationProps } from 'antd';
import styled from 'styled-components';
import { getRecordCountLabel } from '../utils/pagination';

const CustomPagination = styled(PaginationComponent)`
  .ant-pagination-item-active a,
  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a,
  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #00b27b;
  }
  .ant-pagination-item-active,
  .ant-pagination-options-quick-jumper input:hover {
    border-color: #00b27b;
  }
  .ant-pagination-options-quick-jumper input:focus,
  .ant-pagination-options-quick-jumper input-focused {
    box-shadow: none;
    border-radius: 3px;
  }
  .ant-pagination-total-text {
    color: #818181;
    margin-right: 16px;
    flex-shrink: 0;
  }
  display: flex;
  justify-content: flex-end;
  flex-shrink: 1;
  margin: 30px 0 10px;
`;

const Pagination = ({ className = '', total, ...props }: PaginationProps) => (
  <CustomPagination
    {...props}
    total={total}
    className={className}
    showSizeChanger={false}
    size='small'
    showQuickJumper
    showTotal={total ? getRecordCountLabel : undefined}
  />
);

export default Pagination;
